import { useTheme } from 'styled-components'

import { DatePicker } from '@components/DatePicker'

import { FormLabel } from './FormLabel'

interface IProps {
  onChange: (selectedDate: Date) => void
  mode: 'time' | 'date'
  label?: string
  errorMessage?: string
  isRequired?: boolean
  value?: Date
  minimumDate?: Date
  maximumDate?: Date
  isDisabled?: boolean
}

export function FormDatePicker({
  onChange,
  label,
  errorMessage,
  isRequired,
  value,
  ...rest
}: IProps) {
  const { colors } = useTheme()

  const invalid = !!errorMessage

  const borderColor = invalid ? colors.textError : colors.formBorder
  const borderWidth = invalid ? 2 : 1

  return (
    <div style={{ marginBottom: 16 }}>
      <FormLabel isInvalid={invalid} isRequired={isRequired}>
        {label}
      </FormLabel>
      <DatePicker
        onDateChange={onChange}
        updatedDate={value}
        borderColor={borderColor}
        borderWidth={borderWidth}
        {...rest}
      />

      {invalid && <span style={{ color: colors.textError, fontSize: 12 }}>{errorMessage}</span>}
    </div>
  )
}
